import { addCoreAgentConversationTitles } from '../titles/actions';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { ErrorOrFailStatusCode } from '@sonar-software/sonar-http';
import { searchConversations, SearchConversationsRequest } from '@api';

export const getCoreAgentConversationSearchSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [
			(result) => addCoreAgentConversationTitles(result.items.map(({ conversationId, title }) => ({
				id: conversationId,
				title
			})))
		]
	},
	name: 'coreAgentConversationSearch',
	receive: true,
	request: true,
	// xuder only reports a rejected fetch globally, which would leave the search requested with no Retry.
	requestHandler: (request: SearchConversationsRequest) => searchConversations(request).catch(() => ({
		headers: new Headers(),
		status: ErrorOrFailStatusCode.RequestTimeout
	})),
	retainDataOnRequest: true
});
